import { useDispatch, useSelector } from 'react-redux'
import { GET_STORE } from '@wellbeingxltd/fe-lib/constants'
import { getGoalTagsList } from 'actions/lists'

export const useWellbeingGoals = () => {
    const dispatch = useDispatch()
    const { goalTags, getGoalsListLoading, getGoalsListError, pillarsGoals } = useSelector(GET_STORE.LISTS)

    return {
        getGoalsListError,
        getGoalsListLoading,
        goalTags,
        getGoalTagsList: () => dispatch(getGoalTagsList()),
        pillarsGoals,
    }
}
